module.exports = __webpack_public_path__ + "static/media/play-game.f919d970.svg";